import general from './general'
import style from '../style'

/**
 * Represents the error types available.
 */
export type ErrorType = 'general'

/**
 * Determine the error options.
 */
export interface ErrorOptions {
  color: string
  text: string
  size: [number, number]
  textColor: string
  type: ErrorType
  debug: boolean
}

/**
 * HTML Errors available.
 */
const errors = {
  general,
}

export const error = (options: ErrorOptions, error: Error) => `
    <div style="${style.chartisanHelpBlock}">
    <div class="chartisan-refresh-chart" style="${style.chartisanRefreshChart}">
        ${errors[options.type](options)}
    </div>
    ${
      options.text != ''
        ? `
            <div style="color: ${options.textColor}; ${style.chartisanHelpText}">
                ${options.text}
            </div>
            `
        : ''
    }
    ${
      options.debug
        ? `
            <div style="${style.chartisanHelpTextError}">
                ${error.message}
            </div>`
        : ''
    }
    </div>
`
